<div #container class="skeleton-table-container">
  <table class="tabla-aleema">
    <thead>
      <tr>
        @for (col of colArray; track $index) {
          <th>
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '10px',
                height: '12px',
                width: '75%',
                margin: '0'
              }"
            />
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of rowArray; track $index) {
        <tr>
          @for (col of colArray; track $index) {
            <td>
              <ngx-skeleton-loader
                [theme]="{
                  'border-radius': '10px',
                  height: '12px',
                  width: '80%',
                  margin: '4px 0'
                }"
              />
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>